import React from "react";
import FinishedMessage from "../organisms/FinishedMessage";
const Thanks = () => {
    return React.createElement(FinishedMessage, null);
};
export default Thanks;
